module.exports = __webpack_public_path__ + "static/media/iPhone@3x.7ddfdb18.png";